import React, { useState } from 'react';

const Contact: React.FC = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    // Ici, tu pourrais envoyer le formulaire à une API ou un service
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center py-8 px-4">
      <div className="w-full max-w-lg bg-white rounded-lg shadow-md p-8">
        <h1 className="text-2xl font-bold mb-4 text-center">Contactez-nous</h1>
        <p className="mb-6 text-center text-gray-600">Une question, une suggestion ou besoin d'aide ? Remplissez le formulaire ou contactez-nous directement.</p>
        <div className="mb-6 text-center">
          <p className="text-gray-700"><strong>Email :</strong> support@geniusvente.com</p>
          <p className="text-gray-700"><strong>Téléphone :</strong> +243 842 613 999</p>
        </div>
        {submitted ? (
          <div className="text-green-600 text-center font-semibold py-8">Merci pour votre message ! Nous vous répondrons rapidement.</div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="name" className="block text-gray-700 font-medium mb-1">Nom</label>
              <input
                type="text"
                id="name"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#0D3C4C]"
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-gray-700 font-medium mb-1">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#0D3C4C]"
              />
            </div>
            <div>
              <label htmlFor="message" className="block text-gray-700 font-medium mb-1">Message</label>
              <textarea
                id="message"
                name="message"
                value={form.message}
                onChange={handleChange}
                required
                rows={4}
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#0D3C4C]"
              />
            </div>
            <button
              type="submit"
              className="w-full bg-[#0D3C4C] text-white font-semibold py-2 rounded hover:bg-[#14506b] transition-colors"
            >
              Envoyer
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Contact; 